import { render, staticRenderFns } from "./yearList.vue?vue&type=template&id=1f5c235e&scoped=true&"
import script from "./yearList.vue?vue&type=script&lang=js&"
export * from "./yearList.vue?vue&type=script&lang=js&"
import style0 from "./yearList.vue?vue&type=style&index=0&id=1f5c235e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c235e",
  null
  
)

export default component.exports